import * as React from 'react'
import Box from '@mui/material/Box'
import type { BarSegment } from '../../allDayBars'
import { EventTile, type EventTileVariant } from './EventTile'

type Props = {
  segment: BarSegment
  variant: EventTileVariant
  /** First grid column of the row's day 0 (1-based). */
  firstColumn: number
  /** Grid row of lane 0 (1-based). */
  firstRow: number
  /** Fixed bar height; the month grid lines bars up with reserved slots. */
  heightPx?: number
  topOffsetPx?: number
}

/** One all-day bar placed on a grid, spanning the columns of its segment. */
export function PositionedBar({
  segment,
  variant,
  firstColumn,
  firstRow,
  heightPx,
  topOffsetPx,
}: Props) {
  const { event, startCol, endCol, lane, continuesBefore, continuesAfter } =
    segment

  return (
    <Box
      data-test-id="all-day-bar"
      data-start-col={startCol}
      data-end-col={endCol}
      data-lane={lane}
      sx={{
        gridColumn: `${firstColumn + startCol} / ${firstColumn + endCol + 1}`,
        gridRow: firstRow + (heightPx ? 0 : lane),
        position: 'relative',
        zIndex: 2,
        minWidth: 0,
        alignSelf: 'start',
        height: heightPx,
        mt: topOffsetPx === undefined ? undefined : `${topOffsetPx}px`,
        pl: continuesBefore ? 0 : '4px',
        pr: continuesAfter ? 0 : '4px',
        '& > *': { height: heightPx ? '100%' : undefined },
      }}
    >
      <EventTile
        event={event}
        variant={variant}
        continuesBefore={continuesBefore}
        continuesAfter={continuesAfter}
      />
    </Box>
  )
}
